import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Card, { CardSection } from '@lightspeed/cirrus-card';
import { Divider } from '@lightspeed/flame/Divider';

import Layout, { LayoutContent } from 'cirrus/Layout';

import Pager from 'pages/containers/Pager';
import SearchBar from 'pages/containers/SearchBar';
import { getData, clearData } from 'pages/store/actions/data';
import { entities } from 'pages/store/schema';
import { getValues, getMeta, getProcessing } from 'pages/store/selectors';
import { actionTypes } from 'pages/store/actions/defaults';

import AuditTrailListing from './AuditTrailListing';
import AuditTrailHeader from './AuditTrailHeader';

const pageSize = { 'page[size]': 50 };

export class AuditTrail extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (!prevState.dataInit && !nextProps.isLoading) {
      return {
        dataInit: true,
      };
    }

    return null;
  }

  constructor(props) {
    super(props);

    this.state = {
      dataInit: false,
    };
  }

  componentDidMount() {
    window.merchantos.asyncSubscribe.notifySubscribers('react.mount.topbar', {
      props: {
        crumbs: [
          {
            type: 'ui_tab',
            text: 'Settings',
            name: 'admin',
          },
          {
            text: 'Audit Trail',
          },
        ],
      },
    });

    this.getListingData(this.props.location.search);
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    if (location.search !== prevProps.location.search) {
      this.getListingData(location.search);
    }
  }

  componentWillUnmount() {
    this.props.clearData();
  }

  getListingData(search) {
    this.props.getData(`/admin/auditlogs${search}`, { params: { ...pageSize } });
  }

  render() {
    const { logs, meta = {}, isLoading } = this.props;
    const { dataInit } = this.state;
    const { pagination = {} } = meta;

    return (
      <Layout>
        <LayoutContent>
          <AuditTrailHeader />
        </LayoutContent>
        <Divider />
        <LayoutContent>
          <Card>
            <CardSection noSpacing>
              <div className="listing__filters cr-flex cr-width-full cr-justify-between cr-ph-3 cr-pv-2 no_print">
                <SearchBar placeholder="Search" label="Search" />
                <Pager {...{ pagination }} />
              </div>
              <Divider />
            </CardSection>
            <CardSection noSpacing>
              <AuditTrailListing logs={logs} isLoading={isLoading} dataInit={dataInit} />
            </CardSection>
            <CardSection noSpacing>
              <Divider />
              <div className="listing__filters cr-flex cr-width-full cr-ph-3 cr-pv-2 no_print">
                <Pager {...{ pagination }} style={{ marginLeft: 'auto' }} />
              </div>
            </CardSection>
          </Card>
        </LayoutContent>
      </Layout>
    );
  }
}

AuditTrail.defaultProps = {
  isLoading: true,
};

AuditTrail.propTypes = {
  isLoading: PropTypes.bool,
};

const mapStateToProps = state => ({
  logs: getValues(entities.auditLog)(state),
  meta: getMeta({ entity: entities.auditLog, list: true })(state),
  isLoading: getProcessing({
    entity: entities.auditLog,
    list: true,
    actionType: actionTypes.LOADING,
  })(state),
});

const mapDispatchToProps = dispatch => ({
  getData: (url, options, onSuccess) =>
    dispatch(getData({ url, entity: entities.auditLog, list: true, options, onSuccess })),
  clearData: () => dispatch(clearData(entities.auditLog)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AuditTrail);
